import { z } from 'zod'

export const ToastableSchema = z.object({
  errorResolutionType: z.literal('TOAST'),
})
